import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import AntTable from "../../../components/AntTable/AntTable";
import HeaderTableSuperAdmin from "../../../components/admin/common/HeaderTableSuperAdmin";
import AddTeamMember from "../../teamMember/creatTeamMember/AddTeamMember";
type Props = {
  data: any;
  isLoading: boolean;
  setSearchHeader: any;
  setIsFilter: any;
  searchHeader: any;
  page: any;
  setPage: any;
  salonId: number;
};

const StaffMembers = ({
  data,
  isLoading,
  setIsFilter,
  setSearchHeader,
  searchHeader,
  page,
  setPage,
  salonId,
}: Props) => {
  console.log(data?.salon?.id, "288213712389");

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [modal, setModal] = useState(false);
  const [selectedTeamMember, setSelectedTeamMember] = useState<number | null>(
    null
  );
  const navigate = useNavigate();
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState({
    title: "",
    para: "",
    status: "",
    color: "",
  });

  const closeModal = () => {
    setModal(false);
    setSelectedTeamMember(null);
  };
  const openModalTeamMember = () => {
    setModal(true);
  };
  const showModalConfirm = (
    title: string,
    para: string,
    status: string,
    color: string
  ) => {
    setConfirmMessage({ title, para, status, color });
    setIsModalConfirmOpen(true);
  };
  const closeModalConfirm = () => {
    setIsModalConfirmOpen(false);
  };
  const columns: ColumnsType<any> = [
    {
      title: <div>Name</div>,
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="text-[#9999A7] text-sm font-medium">{record?.name}</div>
      ),
    },
    {
      title: <div>Email</div>,
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="text-color-primary text-sm font-medium" dir="ltr">
          {record?.email}
        </div>
      ),
    },
    {
      title: <div>Phone number</div>,
      dataIndex: "display_all_booking",

      render: (text: any, record) => (
        <div className="text-[#9999A7] text-sm font-medium">
          <span className="text-color-primary mx-1 font-semibold">
            {record?.phone}
          </span>
        </div>
      ),
    },
    {
      title: <div>Profession</div>,
      dataIndex: "totalSales",
      render: (text: any, record) => (
        <div className="text-[#9999A7]">
          <span className="text-color-primary text-sm font-medium">
            {record?.title}
          </span>
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className="w-fit"
          onClick={() => {
            openModalTeamMember();
            setSelectedTeamMember(record?.id);
          }}
        >
          <AiOutlineEdit />
        </div>
      ),
    },
  ];
  const actionItems = [
    {
      color: "#C43535",
      text: "Delete Team Members",
      title: "Confirm Deletion",
      description: "Are you sure you want to delete this Team Members?",
      status: "delete",
    },
  ];
  console.log(salonId, "salonId5555");
  return (
    <>
      {selectedTeamMember ? (
        <AddTeamMember
          visible={modal}
          onClose={closeModal}
          config={{
            isAdmin: true,
            locationId: data?.id,
            locationName: data?.name,
            isEdit: true,
            salonName: data?.name,
            teamMemberId: selectedTeamMember,
            salonId,
          }}
        />
      ) : null}

      <div className="w-full h-full">
        <h4 className="text-color-primary font-semibold text-xl">
          Staff Members
        </h4>
        <AntTable
          tableColumns={columns}
          tableHeader={
            <div className="flex items-center justify-end">
              <HeaderTableSuperAdmin
                searchHeader={searchHeader}
                setSearchHeader={setSearchHeader}
                selectedRowKeys={selectedRowKeys}
                labelButton="New Member"
                modalId={0}
                filterType={{ dateAdded: true }}
                data={{ ...data, salonId }}
                setIsFilter={setIsFilter}
                actionItems={actionItems}
                // requestDelete={deleteSalonStatus}
                confirmMessage={confirmMessage}
                setConfirmMessage={setConfirmMessage}
                isModalConfirmOpen={isModalConfirmOpen}
                closeModalConfirm={closeModalConfirm}
                showModalConfirm={showModalConfirm}
                placeholderSearch={"Search team member"}
              />
            </div>
          }
          tableData={data}
          isLoading={isLoading}
          onRow={(record: any) => ({
            onClick: () => {
              console.log(record);
              navigate(`${record.id}`);
            },
          })}
          expandRowByClick={false}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          selectionType={selectedRowKeys}
          setPage={setPage}
          page={page}
          total={data?.meta?.total}
        />
      </div>
    </>
  );
};

export default StaffMembers;
